import type {
  CurrentAccount,
  Plan,
  Result,
} from '../useAlertBanner/alertBannerNotificationsQuery';

const PRO_PLAN_NAME = 'Pro (2,000 Tasks)';
const PRO_PLAN_INTERVAL = 'year';

type BuildUpgradeUrlOpts = {
  currentPlanName: string;
  upgradePlanName: string;
  interval: 'month' | 'year';
};
export const buildUpgradeUrl = (opts: BuildUpgradeUrlOpts) => {
  const currentPlanName = (opts.currentPlanName || '').toLowerCase();
  const upgradePlanName = (opts.upgradePlanName || '').toLowerCase();
  const url =
    currentPlanName && upgradePlanName
      ? `/app/checkout/upgrade/${currentPlanName}/${upgradePlanName}?interval=${
          opts.interval || 'month'
        }`
      : '/app/pricing';
  return encodeURI(url);
};

/**
 *
 * Evaluate offers for a specific campaign
 * https://coda.io/d/Revenue-Growth_d_s-Io-GBfk/Project-Sunset_su-G7#_luEdl
 *
 * Render only if no offer for this campaign has been already accepted or has expired
 */
export const getShouldRenderSunsetCopy = (
  campaignOffers: Result['data']['currentAccount']['campaignOffers'] = []
) => {
  // if one of the offers got accepted, user is filtered out of our target
  // expiry dates will be the same for all Sunset offers
  const hasSunsetOffer =
    campaignOffers.length &&
    campaignOffers.every(
      (offer) =>
        !offer.acceptedAt &&
        offer.expiry &&
        new Date(offer.expiry) >= new Date()
    );

  return hasSunsetOffer;
};

export const getProfessionalPlanData = (
  possiblePlans: Array<{
    planType: string;
    plans: Array<Plan>;
  }>,
  currentAccount: CurrentAccount
) => {
  const professionalPlan = possiblePlans
    .find((plan) => plan.planType === 'Professional')
    ?.plans.find(
      (plan) =>
        plan.name === PRO_PLAN_NAME && plan.interval === PRO_PLAN_INTERVAL
    ); // annual pro plan

  const professionalUpgradeUrl = buildUpgradeUrl({
    currentPlanName: currentAccount.plan.name,
    upgradePlanName: professionalPlan?.name || PRO_PLAN_NAME,
    interval: currentAccount.plan.interval,
  });

  // Divide by 12 since `nextPlan` is always annual.
  const professionalPlanAmount = (professionalPlan?.amount || 0) / 12;

  return { professionalUpgradeUrl, professionalPlanAmount };
};
